import script from "./AiOrderDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./AiOrderDrawer.vue?vue&type=script&setup=true&lang=js"

import "./AiOrderDrawer.vue?vue&type=style&index=0&id=22f9effe&lang=css"
import "./AiOrderDrawer.vue?vue&type=style&index=1&id=22f9effe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22f9effe"]])

export default __exports__